enum NumberTypes {
    Phone = "Phone",
    Home = "Home",
    Mobile = "Mobile",
    Business = "Business",
    Other = "Other"
}

export default NumberTypes;